import { BaseAnalytics } from '@r1-frontend/analytics/dataLayerPush';
import UnifiedAddressFormAnalytics from '@r1-frontend/unified-address-form/analytics';

import AddressPageAnalytics from '~/src/features/full-buy/analytics/AddressPage.analytics';
import ContactsAnalytics from '~/src/features/full-buy/analytics/Contacts.analytics';
import CreateAgreementAnalytics from '~/src/features/full-buy/analytics/CreateAgreement.analytics';
import EquipmentsAnalytics from '~/src/features/full-buy/analytics/Equipments.analytics';
import FeedbackAnalytics from '~/src/features/full-buy/analytics/Feedback.analytics';
import FinalAnalytics from '~/src/features/full-buy/analytics/Final.analytics';
import SubscriptionsAnalytics from '~/src/features/full-buy/analytics/Subscriptions.analytics';
import SummaryAnalytics from '~/src/features/full-buy/analytics/Summary.analytics';
import TariffAnalytics from '~/src/features/full-buy/analytics/Tariff.analytics';
import TimeSlotsAnalytics from '~/src/features/full-buy/analytics/TimeSlots.analytics';
import { ESteps } from '~/src/features/full-buy/types';

class FullBuyAnalytics extends BaseAnalytics {
    summary!: SummaryAnalytics;
    tariff!: TariffAnalytics;
    subscriptions!: SubscriptionsAnalytics;
    equipment!: EquipmentsAnalytics;
    unifiedAddressForm!: UnifiedAddressFormAnalytics;
    address!: AddressPageAnalytics;
    feedback!: FeedbackAnalytics;
    contacts!: ContactsAnalytics;
    createAgreement!: CreateAgreementAnalytics;
    timeSlots!: TimeSlotsAnalytics;
    final!: FinalAnalytics;

    constructor(category = 'full-buy') {
        super();
        this.category = category;

        this.summary = new SummaryAnalytics(this.category);
        this.tariff = new TariffAnalytics(this.category);
        this.subscriptions = new SubscriptionsAnalytics(this.category);
        this.equipment = new EquipmentsAnalytics(this.category);
        this.unifiedAddressForm = new UnifiedAddressFormAnalytics(this.category);
        this.address = new AddressPageAnalytics(this.category);
        this.feedback = new FeedbackAnalytics(this.category);
        this.contacts = new ContactsAnalytics(this.category);
        this.createAgreement = new CreateAgreementAnalytics(this.category);
        this.timeSlots = new TimeSlotsAnalytics(this.category);
        this.final = new FinalAnalytics(this.category);
    }

    initializationByTariffLine(message = '') {
        this.send('open_tariffline', message);
    }

    clickGuide(step: ESteps | undefined) {
        this.send('click_guide', step);
    }

    clickBanner(tariffName: string) {
        this.send('choose_recommended_tariff_banner', tariffName);
    }

}

export default FullBuyAnalytics;
